import { memo } from 'react';

import { merge } from '@/components';
import { LightningIcon } from '@/components/icons';
import { toAppClientId, useGetAppClient } from '@/hooks/api';
import { DivProps } from '@/utils';

export type AppClientProps = DivProps & {
  appClientId?: string | null;
};

const IAppClient = ({ appClientId, className, ...rest }: AppClientProps) => {
  const { data: appClient } = useGetAppClient(toAppClientId(appClientId));

  if (!appClient) <div className="size-6 animate-pulse rounded-full bg-gray-200" />;

  return (
    <div className={merge('flex items-center gap-2', className)} {...rest}>
      <LightningIcon className="!text-trigger !size-6" />
    </div>
  );
};

export const AppClient = memo(IAppClient) as typeof IAppClient;
